var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ui-view",
    { staticClass: "view-boatman" },
    [
      _c(
        "ui-heading",
        { attrs: { title: "Gebruikers", icon: "fa-user-circle-o" } },
        [
          _c(
            "ui-button",
            {
              attrs: {
                color: "positive",
                icon: "magicon-plus",
                route: "user-add",
              },
            },
            [_vm._v("Gebruiker toevoegen")]
          ),
          _c("ui-searchbar", {
            model: {
              value: _vm.search,
              callback: function ($$v) {
                _vm.search = $$v
              },
              expression: "search",
            },
          }),
        ],
        1
      ),
      _c(
        "ui-table-panel",
        {
          directives: [
            {
              name: "spinner",
              rawName: "v-spinner",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          attrs: {
            clickable: "",
            placeholder: _vm.users && !_vm.users.items.length,
            total: _vm.$safe("users.totalCount"),
            visible: _vm.paging.limit,
          },
          on: { page: _vm.switchPage },
        },
        [
          _c(
            "ui-table-header",
            [
              _c(
                "ui-th",
                {
                  attrs: { weight: "3", field: "username" },
                  model: {
                    value: _vm.sort,
                    callback: function ($$v) {
                      _vm.sort = $$v
                    },
                    expression: "sort",
                  },
                },
                [_vm._v("Gebruikersnaam")]
              ),
              _c(
                "ui-th",
                {
                  attrs: { weight: "3", field: "email" },
                  model: {
                    value: _vm.sort,
                    callback: function ($$v) {
                      _vm.sort = $$v
                    },
                    expression: "sort",
                  },
                },
                [_vm._v("E-mail adres")]
              ),
              _c(
                "ui-th",
                {
                  attrs: { weight: "2", field: "growerId" },
                  model: {
                    value: _vm.sort,
                    callback: function ($$v) {
                      _vm.sort = $$v
                    },
                    expression: "sort",
                  },
                },
                [_vm._v("Kweker")]
              ),
              _c(
                "ui-th",
                {
                  attrs: { weight: "2", field: "shipId" },
                  model: {
                    value: _vm.sort,
                    callback: function ($$v) {
                      _vm.sort = $$v
                    },
                    expression: "sort",
                  },
                },
                [_vm._v("Schip")]
              ),
              _c(
                "ui-th",
                {
                  attrs: { weight: "2", field: "phoneNumber" },
                  model: {
                    value: _vm.sort,
                    callback: function ($$v) {
                      _vm.sort = $$v
                    },
                    expression: "sort",
                  },
                },
                [_vm._v("Telefoonnummer")]
              ),
              _c("ui-th", { attrs: { weight: "1" } }),
            ],
            1
          ),
          _vm._l(_vm.$safe("users.items"), function (user) {
            return _c("ui-tr", { key: user.id, attrs: { click: "edit" } }, [
              _c("td", [_vm._v(_vm._s(user.username))]),
              _c("td", [_vm._v(_vm._s(user.email))]),
              _c("td", [
                _vm._v(_vm._s(_vm._f("empty")((user.grower || {}).name))),
              ]),
              _c("td", [
                _vm._v(_vm._s(_vm._f("empty")((user.ship || {}).name))),
              ]),
              _c("td", [_vm._v(_vm._s(_vm._f("empty")(user.phoneNumber)))]),
              _c(
                "td",
                {
                  staticClass: "actions",
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                    },
                  },
                },
                [
                  _c("ui-link", {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: "Wijzigen",
                        expression: "'Wijzigen'",
                      },
                    ],
                    attrs: {
                      icon: "magicon-edit",
                      action: "edit",
                      to: { name: "user-edit", params: { id: user.id } },
                    },
                  }),
                  _c("ui-link", {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: "Verwijderen",
                        expression: "'Verwijderen'",
                      },
                    ],
                    attrs: { icon: "magicon-trash" },
                    on: {
                      click: function ($event) {
                        return _vm.deleteUser(user.id)
                      },
                    },
                  }),
                ],
                1
              ),
            ])
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }